import { DatePipe } from "@angular/common";
import { Component, Inject, Input, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA, throwMatDialogContentAlreadyAttachedError } from "@angular/material/dialog";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { BehaviorSubject } from "rxjs";
import { DynamicFormComponent } from "src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component";
import { FieldConfig } from "src/app/CommonComponents/dynamic-form/interface/field.interface";
import { CommonService } from "src/app/Service/Common.service";
import { DocumentRevisionLinkService } from "src/app/Service/document-revision-link/document-revision-link.service";
import { Module } from "src/app/Service/element-details.data.service";
import { NotificationService } from "src/app/Service/notification.service";
import { ProjectInfoService } from "src/app/Service/project-info/project-info.service";
import { ProjectMasterService } from "src/app/Service/projectmaster/projectmaster.service";
import { ScheduleDefinitionService } from "src/app/Service/scheduledefintion/scheduledefintion.service";
import { ScheduleDocumentService } from "src/app/Service/scheduledocument/scheduleDocument.service";
import { BusinessGroupModel } from "src/app/ViewModel/BusinessGroupModel";
import { IDCIViewModel } from "src/app/ViewModel/DCIViewModels";
import { EIPAutoCompleteEventModel } from "src/app/ViewModel/EIPAutoCompleteEventModel";
import { IDCIRevisionMaster, IProjectElementDetailsOutput, IProjectElementsOutput, IProjectFeatureOutput } from "src/app/ViewModel/ProjectElementsModel";
import { IProjectMasterViewModel } from "src/app/ViewModel/ProjectMasterModel";
import { IDocSetModel, IStageElementDetails } from "src/app/ViewModel/ScheduleDefinitionModel";
import { ICPCDocOutputModel, ICPCInputModel, IRevisionCategory, IScheduleBulkInsertModel, IScheduleDocDetails, IScheduleDocInfo, IScheduleDocModel, IScheduleDocRevModel, IScheduleDocStageDetails, IScheduleMHDetails, IScheduleStageId, IScheduleType, IScheduleWFPlanDetails, IScheduleWFPlanStageDetails, IScheduleWorkflowDetails, IWBSOutputModel } from "src/app/ViewModel/ScheduleDocumentModel";
import { StandardOutputModel } from "src/app/ViewModel/StandardOutputModel";
import { WorkflowTemplateModel } from "src/app/ViewModel/WorkflowTemplateModel";

interface IStageDates {
    minDate: Date | null,
    maxDate: Date | null,
    value: Date | null
}

@Component({
    selector: 'app-schedule-edit',
    templateUrl: './schedule-edit.component.html',
    styleUrls: ['./schedule-edit.component.css']
})
export class ScheduleEditComponent {
    private _schDoc: IScheduleDocInfo;
    private _dciViewModel!: IDCIViewModel;
    private _superEdit: boolean;
    projectId!: number;
    memberId!: number;
    groupId!: number;
    get schDoc(): IScheduleDocInfo {
        return this._schDoc;
    }
    @Input() set schDoc(value: IScheduleDocInfo) {
        if (!!value && typeof value == "object") {
            this._schDoc = value;
            this.fetchDciViewDocDetails();
        }
    }
    public panelOpenState = true;
    @ViewChild('dciElementDetailsForm') dciElementDetailsForm!: DynamicFormComponent;
    @ViewChild('dciNoForm') dciNoDynamicForm!: DynamicFormComponent;
    @ViewChild('dciTitleForm') dciTitleDynamicForm!: DynamicFormComponent;
    @ViewChild('dciMHdetailsForm') dciMHDetailsDynamicForm!: DynamicFormComponent;
    @ViewChild('dciApprovalBy') dciApprovalByDynamicForm!: DynamicFormComponent;
    @ViewChild('dciDocsetAndStages') dciDocsetAndStagesForm!: DynamicFormComponent;
    @ViewChild('dciRevision') dciRevisionForm!: DynamicFormComponent;

    dciForm!: FormGroup;
    docScheduleForm!: FormGroup;
    revForm!: FormGroup;
    printSizeList: IProjectElementDetailsOutput[] = [];
    selectedPrintSize!: number;
    dciStatusList: IProjectElementDetailsOutput[] = [];
    selectedDciStatus!: number;
    isCanApprove: boolean = false;
    revCategoryList: IRevisionCategory[] = [];
    selectedRevCategory!: number;
    inputRequiredOptions: any[] = [{ value: true, name: "Required" }, { value: false, name: "Not Required" }];
    schTypeOptions: IScheduleType[] = [{ schType_Id: 1, schType_Name: "DCI" }, { schType_Id: 2, schType_Name: "Ext DCI" }, { schType_Id: 3, schType_Name: "Std DCI" }, { schType_Id: 4, schType_Name: "Vendor DCI" }];
    projBusinessGroups: BusinessGroupModel[] = [];
    selectedApprovalBy!: number;
    approverList: IProjectFeatureOutput[] = [];
    selectedAuthorisedBy!: number;
    scheduleWFPlanStageDetails: IScheduleWFPlanStageDetails[] = [];
    structPackEleId!: number;
    workflowList: WorkflowTemplateModel[] = [];
    selectedWorkflow!: number;
    docSetList: IDocSetModel[] = [];
    filteredDocSetList: IDocSetModel[] = [];
    selectedDocSet?: number;
    selectedDocSetStageDetails: IStageElementDetails[] = [];
    IsDisabled: boolean = true;
    stageDates: Map<string, IStageDates> = new Map<string, IStageDates>();
    isDocSetRequired: boolean = true;
    isWBSIntegration: boolean = false;
    projectStaticElements: IProjectElementsOutput[] = [];
    isAutoRevision: boolean = false;
    dciRevisionList: IDCIRevisionMaster[] = [];
    wbsList: any = [];
    dvcodeList: any = [];
    JOBCode!: string;
    WBSCode!: string | null;
    DeliverableCode!: number | null;
    docCategoryList: IProjectElementDetailsOutput[] = [];
    Visible_doccatelist: boolean = false;
    selectedDCICodeIdValue: number = 0;
    SetDCIMaxProgressLevel: IProjectElementsOutput;
    ProgressLevelsList: IProjectElementDetailsOutput[];
    selectedMaxProgressLevel: number;

    constructor(private _projService: ProjectInfoService,
        private _scheduleDocService: ScheduleDocumentService,
        private _notificationService: NotificationService,
        private _commonService: CommonService,
        private _formBuilder: FormBuilder,
        private _scheDefService: ScheduleDefinitionService,
        public _datepipe: DatePipe, public _dialogRef: MatDialogRef<ScheduleEditComponent>,
        private _dciRevMaster: DocumentRevisionLinkService,
        private _projectService: ProjectMasterService,
        @Inject(MAT_DIALOG_DATA) public _data: any) {
        this._schDoc = this._data.dataItem;
        this._superEdit = this._data.isSuperEdit;
    }

    ngOnInit(): void {
        this.projectId = this._commonService.getProjectId();
        this.memberId = this._commonService.getLoggedInUserId();
        this.groupId = this._commonService.getLoggedInUserGroupId();
        this.getProjectStaticElements();
        this.fetchDciViewDocDetails();
        this.getWBSCodes();
    }

    createDCIForm() {
        this.dciForm = this._formBuilder.group({
            dciSerialNo: new FormControl({ value: '', disabled: !this._superEdit }),
            title: new FormControl({ value: '', disabled: !this._superEdit }, [Validators.required]),
            enggManhours: new FormControl('', [Validators.pattern("^[0-9]*\.?[0-9]*$")]),
            draftingManHours: new FormControl('', [Validators.pattern("^[0-9]*\.?[0-9]*$")]),
            weightage: new FormControl('', Validators.pattern("^[0-9]*\.?[0-9]*$")),
            inputRequired: new FormControl(false),
            schType: new FormControl(''),
            wbsCode: new FormControl(),
            dvCode: new FormControl()
        });
        this.docScheduleForm = this._formBuilder.group({
            approvalBy: new FormControl('', Validators.required),
            formApprovalBy: new FormControl('', Validators.required),
            workflow: new FormControl('', Validators.required),
            formWorkflow: new FormControl('', Validators.required),
            docSet: new FormControl('', Validators.required),
            formDocSet: new FormControl('', Validators.required),
            MaxProgressLevel: new FormControl(),
            formMaxProgressLevel: new FormControl()
        });
        this.revForm = this._formBuilder.group({
            dciStatus: new FormControl('', [Validators.required]),
            formDciStatus: new FormControl('', [Validators.required]),
            DocumentCategory: new FormControl(),
            revision: new FormControl({ value: '', disabled: true }, [Validators.required]),
            authorisedBy: new FormControl('', [Validators.required]),
            formAuthorisedBy: new FormControl('', [Validators.required]),
            qrCodeTag: new FormControl(true),
            reference: new FormControl(),
            noOfSheets: new FormControl(),
            docCategoryid: new FormControl(),
            revCategory: new FormControl('', Validators.required),
            formrevCategory: new FormControl('', Validators.required),
            printSize: new FormControl('', [Validators.required]),
            formPrintSize: new FormControl('', [Validators.required]),
            comments: new FormControl(),
            isConfidential: new FormControl(true),
        });
    }

    /**
   * Get Element Details (Print Size,Doc Status)
   */
    public getElementDetails(elementName: string, ModuleId?: number) {
        if (!ModuleId)
            ModuleId = Module.UploadDocument
        this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: ModuleId, deDescription: elementName })
            .subscribe((res: IProjectElementDetailsOutput[]) => {
                switch (elementName) {
                    case "Print Size":
                        {
                            this.printSizeList = res;
                            this.selectedPrintSize = this._dciViewModel.print_Size_Id;
                            this.setFormValue(this.revForm, "formPrintSize", this.selectedPrintSize);
                        }
                        break;
                    case "Status":
                        {
                            this.dciStatusList = res;
                            this.selectedDciStatus = this._dciViewModel.doc_Status_Id;
                            this.setFormValue(this.revForm, "formDciStatus", this.selectedDciStatus);
                        }
                        break;
                    case "Document Category":
                        {
                            if (this._dciViewModel && this._dciViewModel.dciCodeId) {
                                this.docCategoryList = res;
                                this.selectedDCICodeIdValue = this._dciViewModel.dciCodeId;
                                this.setFormValue(this.revForm, "DocumentCategory", this.selectedDCICodeIdValue);
                                this.Visible_doccatelist = true;
                            }
                            else
                                this.Visible_doccatelist = false;
                        }
                        break;
                    case "Progress Level":
                        this.ProgressLevelsList = res;
                        this.selectedMaxProgressLevel = this._dciViewModel.max_ProgressLevel_Id;
                        this.setFormValue(this.revForm, "formMaxProgressLevel", this.selectedMaxProgressLevel);
                        break;
                }
            }, err => { });
    }

    fetchDciViewDocDetails() {
        this.createDCIForm();
        this._scheduleDocService.GetDCIDocumentViewDetails({
            project_Id: this.projectId, group_Id: this.groupId,
            doc_Id: this.schDoc.doc_Id, revision_No: this.schDoc.revision_No
        }).subscribe(x => {
            this._dciViewModel = x;
            this.getElementDetailsForm();
            this.setDciFormValues();
            this.setRevisionFormValues();
            this.getRevisionCategories();
            this.getProjectBusinessGroups();
            this.getWorkflowDetails();
            if (this.isDocSetRequired) {
                this.loadStages();
            }
            else {
                this.loadWorkflowStages();
            }
            this.getApproverList();
            this.getProjectRevisionMaster();
            this.setFormValue(this.revForm, "comments", this._dciViewModel.comments);

        })
    }

    setDciFormValues() {
        this.setFormValue(this.dciForm, "dciSerialNo", this._dciViewModel.doc_No);
        this.setFormValue(this.dciForm, "title", this._dciViewModel.doc_Title);
        this.setFormValue(this.dciForm, "enggManhours", this._dciViewModel.e_Man_Hours);
        this.setFormValue(this.dciForm, "draftingManHours", this._dciViewModel.d_Man_Hours);
        this.setFormValue(this.dciForm, "weightage", this._dciViewModel.weightage);
        this.getElementDetails("Document Category", Module.ScheduleDocument);
        let inputRequired: any = this.inputRequiredOptions.filter(x => x.value == this._dciViewModel.is_Input_Required)[0];
        this.setFormValue(this.dciForm, "inputRequired", inputRequired);
        let schType: IScheduleType = this.schTypeOptions.filter(x => x.schType_Id == this._dciViewModel.schedule_Type)[0];
        this.setFormValue(this.dciForm, "schType", schType);
        this.WBSCode = this._dciViewModel.wbS_Code;
        this.setFormValue(this.dciForm, "wbsCode", this.WBSCode);
        this.DeliverableCode = this._dciViewModel.deliverable_Code;
        this.setFormValue(this.dciForm, "dvCode", this.DeliverableCode);
    }

    setRevisionFormValues() {
        this.getElementDetails("Print Size", Module.ScheduleDocument);
        this.getElementDetails("Status", Module.ScheduleDocument);
        this.getElementDetails("Progress Level", Module.Workflow);
        this.setFormValue(this.revForm, "qrCodeTag", this._dciViewModel.qrCodeStatus);
        this.setFormValue(this.revForm, "reference", this._dciViewModel.reference);
        this.setFormValue(this.revForm, "revision", this._dciViewModel.revision_No);
        this.setFormValue(this.revForm, "noOfSheets", this._dciViewModel.noOfSheets);
        this.setFormValue(this.revForm, "isConfidential", this._dciViewModel.is_Confidential);
    }

    setFormValue(form: FormGroup, formControlName: string, value: any) {
        form.get(formControlName)?.setValue(value);
    }

    /**
  * Get Project business groups
  */
    getProjectBusinessGroups() {
        this._commonService.getProjectBusinessGroups(this._commonService.getProjectId()).subscribe(res => {
            this.projBusinessGroups = res;
            this.selectedApprovalBy = this._dciViewModel.to_Group_Id;
            this.setFormValue(this.docScheduleForm, "formApprovalBy", this.selectedApprovalBy);
        });
    }

    selectedschtype!: number;

    changeButtonToggle(event: { value: { schType_Id: number; }; }) {
        this._scheduleDocService.GetWorkflowList().subscribe((x: WorkflowTemplateModel[]) => {
            this.workflowList = x;
            this.selectedschtype = event.value.schType_Id;
            this.workflowList = this.workflowList.filter(x => x.scheduleType == this.selectedschtype);
            this.selectedWorkflow = this._dciViewModel.workflow_Id;
            this.setFormValue(this.docScheduleForm, "formWorkflow", this.selectedWorkflow);
        })
    }

    getWorkflowDetails() {
        this._scheduleDocService.GetWorkflowList().subscribe((x: WorkflowTemplateModel[]) => {
            this.workflowList = x;
            this.selectedschtype = this._dciViewModel.schedule_Type;
            this.workflowList = this.workflowList.filter(x => x.scheduleType == this.selectedschtype);
            this.selectedWorkflow = this._dciViewModel.workflow_Id;
            this.setFormValue(this.docScheduleForm, "formWorkflow", this.selectedWorkflow);
        })
    }

    getRevisionCategories() {
        this.revCategoryList = [{ revCategoryId: 1, revCategory: 'Minor' }, { revCategoryId: 2, revCategory: 'Major' }, { revCategoryId: 3, revCategory: 'First Release' }];
        this.selectedRevCategory = this._dciViewModel.revision_Category;
        this.setFormValue(this.revForm, "formrevCategory", this.selectedRevCategory);
    }

    public getApproverList() {
        this._projService.getProjectFeatureWiseMembers({ projectId: this.projectId, groupId: this.groupId, featureDescription: 'Approve' })
            .subscribe((res: IProjectFeatureOutput[]) => {
                this.approverList = res;
                this.selectedAuthorisedBy = this._dciViewModel.authorized_By_Id;
                this.setFormValue(this.revForm, "formAuthorisedBy", this.selectedAuthorisedBy);
            }, err => { });
    }


    getElementDetailsForm() {
        let elementsConfig: FieldConfig[] = [];
        elementsConfig = this._dciViewModel.dciScheduleElementDetails.map(x => {
            let field: FieldConfig = { type: "label", label: x.dE_Description, de_id: x.dE_Id, value: new BehaviorSubject(x.deD_Short_Description + "-" + x.deD_Description) }
            return field;
        })
        this.dciElementDetailsForm.fields = [];
        this.dciElementDetailsForm.fields = elementsConfig;
        this.dciElementDetailsForm.createControl();
    }

    onselectedValueChange(val: any, formGroupName: string, formControlName: string) {
        switch (formGroupName) {
            case "docScheduleForm":
                this.docScheduleForm.get(formControlName)?.setValue(val.additionalValues.additionalValues);
                break;
            case "dciForm":
                this.dciForm.get(formControlName)?.setValue(val.additionalValues.additionalValues);
                break;
            case "revForm":
                this.revForm.get(formControlName)?.setValue(val.additionalValues.additionalValues);
                break;
        }
    }

    /**
 * Load document set list
 */
    getDocSetList() {
        this._scheDefService.getDocSetList({ project_Id: this.projectId, group_Id: this.groupId }).subscribe((res: IDocSetModel[]) => {
            this.docSetList = res;
            this.loadStages();
            this.filterDocSet();
        });
    }

    getProjectRevisionMaster() {
        let obj = {
            "projectId": this.projectId,
            "groupId": this.groupId,
        }
        this._dciRevMaster.getDocumentRevision(obj).subscribe((data: IDCIRevisionMaster[]) => {
            this.dciRevisionList = data;
        })
    }

    onStageChange(event: any, stageEleDetail: IStageElementDetails) {
        if (event.checked) {
            let selDate: any = stageEleDetail.selected_Date;
            if (selDate == null)
                selDate = stageEleDetail.end_Date;
            this.scheduleWFPlanStageDetails.push({ sort_By: stageEleDetail.sort_By, status_Id: stageEleDetail.stage_Id, scheduled_On: selDate });
        }
        else {
            let schWfpStageDetails: IScheduleWFPlanStageDetails = this.scheduleWFPlanStageDetails.filter(x => x.status_Id == stageEleDetail.stage_Id)[0];
            if (!!this.scheduleWFPlanStageDetails) {
                let index: number = this.scheduleWFPlanStageDetails.indexOf(schWfpStageDetails);
                if (index > -1)
                    this.scheduleWFPlanStageDetails.splice(index, 1);
            }
        }
        if (this.scheduleWFPlanStageDetails.length > 0) {
            let firstStage: IScheduleWFPlanStageDetails = this.scheduleWFPlanStageDetails.sort((a, b) => a.sort_By - b.sort_By)[0];
            if (!!firstStage && !!this.dciRevisionList && this.dciRevisionList.length > 0) {
                let revision: any = this.dciRevisionList.filter(x => x.stageId == firstStage.status_Id && x.isActive)[0].revisionNo;
                if (!!revision)
                    this.revForm.get('revision')?.setValue(revision);
            }
        }
    }

    private filterDocSet() {
        //reset the last selected document set
        this.selectedDocSetStageDetails = [];
        this.scheduleWFPlanStageDetails = [];
        this.stageDates.clear();
        let docSet: IDocSetModel = this.docSetList.filter(x => x.doc_Set_Id == this._dciViewModel.doc_Set_Id)[0];
        this.filteredDocSetList = this.docSetList.filter(ds => ds.structure_DED_Id == docSet.structure_DED_Id &&
            ds.disc_DED_Id == docSet.disc_DED_Id);
        this.selectedDocSet = docSet.doc_Set_Id;
        this.setFormValue(this.docScheduleForm, "formDocSet", this.selectedDocSet);
    }

    private loadStages() {
        this.docScheduleForm.get('docSet')?.valueChanges.subscribe((res: IDocSetModel) => {
            if (res) {
                //reset the last selected document set
                this.selectedDocSetStageDetails = [];
                this.scheduleWFPlanStageDetails = [];
                this.stageDates.clear();
                this.selectedDocSetStageDetails = res.stageDocumentSetDetails;

                //If the user changes different documentset, need to capture all the details as fresh manner
                if (this._dciViewModel.doc_Set_Id == res.doc_Set_Id && this._dciViewModel.dciScheduleStageDetails.length > 0) {
                    this._dciViewModel.dciScheduleStageDetails.forEach(x => {
                        let stageDetail = this.selectedDocSetStageDetails.filter(y => y.stage_Id == x.stage_Id)[0];
                        if (!!stageDetail) {
                            stageDetail.checked = true;
                            let formattedDate: any = this._datepipe.transform(x.scheduled_On, 'dd-MMM-yyyy');
                            this.scheduleWFPlanStageDetails.push({ sort_By: stageDetail.sort_By, status_Id: x.stage_Id, scheduled_On: formattedDate });
                        }
                    })
                }
                this.selectedDocSetStageDetails.forEach(x => {
                    let stageDate: IStageDates = {
                        minDate: x.start_Date != null ? new Date(x.start_Date) : null,
                        maxDate: x.end_Date != null ? new Date(x.end_Date) : null,
                        value: x.end_Date != null ? new Date(x.end_Date) : null
                    };
                    //this.stageDates.set(x.stage_Id.toString(), stageDate);
                    this.stageDates[x.stage_Id] = stageDate;
                });
            }
        })
    }

    private async loadWorkflowStages() {
        this.docScheduleForm.get('workflow')?.valueChanges.subscribe(async (res: WorkflowTemplateModel) => {
            await this._scheduleDocService.GetWorkflowStageDetails({ project_Id: res.projectId, workflow_Id: res.workflowId }).toPromise().then((stages: IStageElementDetails[]) => {
                this.selectedDocSetStageDetails = [];
                this.scheduleWFPlanStageDetails = [];
                this.stageDates.clear();
                this.selectedDocSetStageDetails = stages;
                //If the user changes different workflow need to capture all the details as fresh manner
                if (this._dciViewModel.workflow_Id == res.workflowId && this._dciViewModel.dciScheduleStageDetails.length > 0) {
                    this._dciViewModel.dciScheduleStageDetails.forEach(x => {
                        let stageDetail = this.selectedDocSetStageDetails.filter(y => y.stage_Id == x.stage_Id)[0];
                        if (!!stageDetail) {
                            stageDetail.checked = true;
                            let formattedDate: any = this._datepipe.transform(x.scheduled_On, 'dd-MMM-yyyy');
                            this.scheduleWFPlanStageDetails.push({ sort_By: stageDetail.sort_By, status_Id: x.stage_Id, scheduled_On: formattedDate });
                        }
                    })
                }
                this.selectedDocSetStageDetails.forEach(x => {
                    let schWorkflowPlanStageDetail: IScheduleWFPlanStageDetails = this.scheduleWFPlanStageDetails.filter(y => y.status_Id == x.stage_Id)[0];
                    let stageDate: IStageDates = { minDate: new Date(x.start_Date), maxDate: new Date(x.end_Date), value: new Date(x.end_Date) };
                    if (!!schWorkflowPlanStageDetail) {
                        stageDate.value = new Date(schWorkflowPlanStageDetail.scheduled_On);
                    }
                    //this.stageDates.set(x.stage_Id.toString(), stageDate);
                    this.stageDates[x.stage_Id] = stageDate;
                });
            })
        })
    }

    async updateScheduleDoc() {
        let result: StandardOutputModel = { result: "", successCode: 400, successMessage: "Mandatory fields are missing" };
        let scheduleDocInput: IScheduleDocModel | null = null;
        let schBulkInsertModel: IScheduleBulkInsertModel;

        if (!!this.isWBSIntegration) {
            if (!!this.WBSCode) {
                if (!!this.DeliverableCode) {

                } else {
                    this._notificationService.showPopup("Kindly select Deliverable Code", "Warning");
                    return;
                }
            }
        }
        if (this.dciForm.valid && this.revForm.valid && this.docScheduleForm.valid) {
            if (this.scheduleWFPlanStageDetails.length > 0) {
                scheduleDocInput = {
                    docId: this._dciViewModel.doc_Id,
                    projectId: this.projectId,
                    groupId: this.groupId,
                    docNo: this.getFormValue(this.dciForm, "dciSerialNo"),
                    docSerialNo: this._dciViewModel.doc_Serial_No,
                    docTitle: this.getFormValue(this.dciForm, "title"),
                    userId: this.memberId,
                    module: Module.ScheduleDocument,
                    MaxProgressLevel: !!this.SetDCIMaxProgressLevel && this.getFormValue(this.docScheduleForm, "MaxProgressLevel") ? this.getFormValue(this.docScheduleForm, "MaxProgressLevel").dedId : null,

                };
                let docSet: IDocSetModel = this.getFormValue(this.docScheduleForm, "docSet");
                if (docSet)
                    scheduleDocInput.docSetId = docSet.doc_Set_Id;
                schBulkInsertModel = {
                    isStandardDrawingDocument: false,
                    dciMasterDetails: scheduleDocInput,
                    dciRevDetails: this.getScheduleDocRevision(),
                    dciSchDetails: this.getScheduleDocDetails(),
                    dciElementDetails: null,
                    dciDocScheduleWFPlanDetails: this.getScheduleDocWFPlanDetails(),
                    dciDocSchMHDetails: this.getScheduleMHDetails(),
                    dciDocSchStageDetails: this.getScheduleRevStageDetails(),
                    dciDocSchWorkflowDetails: this.getScheduleDocWorkflowDetails()

                }
                result = await this._scheduleDocService.InsertScheduleBulkDocument(schBulkInsertModel).toPromise();

                if (!!this.isWBSIntegration) {
                    if (result.successCode == 200 || result.successCode == 205) {
                        let dciCPCDocDetails: ICPCInputModel = {
                            docId: this._dciViewModel.doc_Id,
                            projectId: this.projectId,
                            memberId: this.memberId,
                            wBSCode: this.WBSCode,
                            deliverableCode: this.DeliverableCode
                        }
                        let result1: StandardOutputModel = await this._scheduleDocService.InsertCPCDocDetails(dciCPCDocDetails).toPromise();
                    }
                }
            }
            else {
                this._notificationService.showPopup("Kindly select atleast one stage", "Warning");
                return;
            }
        }
        this._notificationService.showToast(result.successMessage, result.successCode == 200 ? "Success" : "Error");
        if (result.successCode == 200) {
            this._schDoc.doc_Title = scheduleDocInput ? scheduleDocInput.docTitle : "";
            this._schDoc.print_Size = this.getFormValue(this.revForm, "printSize").dedDescription;
            this.closeDialog()
        }
    }

    private getScheduleDocRevision(): IScheduleDocRevModel {
        let scheduleDocRevInput: IScheduleDocRevModel = {
            docId: this._dciViewModel.doc_Id,
            revisionNo: this.getFormValue(this.revForm, "revision"),
            docStatus: this.getFormValue(this.revForm, "dciStatus").dedId,
            isConfidential: this.getFormValue(this.revForm, "isConfidential"),
            printSize: this.getFormValue(this.revForm, "printSize").dedId,
            docAuthorizedBy: this.getFormValue(this.revForm, "authorisedBy").memberId,
            revisionCategory: this.getFormValue(this.revForm, "revCategory").revCategoryId,
            qrCodeStatus: this.getFormValue(this.revForm, "qrCodeTag"),
            comments: this.getFormValue(this.revForm, "comments"),
            reference: this.getFormValue(this.revForm, "reference"),
            noOfSheets: this.getFormValue(this.revForm, "noOfSheets"),
            revisionType: 0,
            docCreatedBy: this.memberId,
            createdBy: this.memberId,
            isActive: true,
            DCICodeId: this.getFormValue(this.revForm, "docCategoryid")

        }
        return scheduleDocRevInput;
    }

    private getScheduleDocWFPlanDetails(): IScheduleWFPlanDetails {
        let schWFPlandetails: IScheduleWFPlanDetails = {
            doc_Id: this._dciViewModel.doc_Id,
            revision_No: this.getFormValue(this.revForm, "revision"),
            docScheduleWFPlanDetails: this.scheduleWFPlanStageDetails,
            is_Active: true,
            userId: this.memberId
        }
        return schWFPlandetails;
    }

    private getScheduleRevStageDetails(): IScheduleDocStageDetails {
        let schDocStageDetails: IScheduleDocStageDetails = {
            doc_Id: this._dciViewModel.doc_Id,
            revision_No: this.getFormValue(this.revForm, "revision"),
            docScheduleStageDetails: this.scheduleWFPlanStageDetails.map(x => {
                let stage: IScheduleStageId = {
                    stage_Id: x.status_Id
                }
                return stage;
            }),
            stage_Id: this.scheduleWFPlanStageDetails.sort((a, b) => a.sort_By - b.sort_By)[0].status_Id,
            is_Active: true,
            userId: this.memberId
        }
        return schDocStageDetails;
    }

    private getScheduleMHDetails(): IScheduleMHDetails {
        let schDocMHDetails: IScheduleMHDetails = {
            doc_Id: this._dciViewModel.doc_Id,
            e_Man_Hours: this.getFormValue(this.dciForm, "enggManhours"),
            d_Man_Hours: this.getFormValue(this.dciForm, "draftingManHours"),
            weightage: this.getFormValue(this.dciForm, "weightage"),
            userId: this.memberId,
            is_Active: true
        }
        return schDocMHDetails;
    }

    private getScheduleDocDetails(): IScheduleDocDetails {
        let schDocDetails: IScheduleDocDetails = {
            doc_Id: this._dciViewModel.doc_Id,
            from_Group_Id: this.groupId,
            to_Group_Id: this.getFormValue(this.docScheduleForm, "approvalBy").group_Id,
            revision_No: this.getFormValue(this.revForm, "revision"),
            schedule_Type: this.getFormValue(this.dciForm, "schType").schType_Id,
            is_Input_Required: this.getFormValue(this.dciForm, "inputRequired").value,
            userId: this.memberId,
            is_Active: true
        }
        return schDocDetails;
    }

    private getScheduleDocWorkflowDetails(): IScheduleWorkflowDetails {
        let schDocWorkflowDetails: IScheduleWorkflowDetails = {
            doc_Id: this._dciViewModel.doc_Id,
            userId: this.memberId,
            is_Active: true,
            workflow_Id: this.getFormValue(this.docScheduleForm, "workflow").workflowId,
            revision_No: this.getFormValue(this.revForm, "revision")
        }
        return schDocWorkflowDetails;
    }

    async getProjectStaticElements() {
        await this._projService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.ScheduleDocument, IsQueryForStaticElement: true }).toPromise().then(
            (res: IProjectElementsOutput[]) => {
                if (res.length > 0) {
                    this.projectStaticElements = res;
                    let revElement: IProjectElementsOutput[] = this.projectStaticElements.filter(x => x.elementDescription == "Auto Revision");
                    if (revElement.length > 0) {
                        this.isAutoRevision = revElement[0].isDefaultSelect;
                    }
                    let isDocSetRequiredElement = this.projectStaticElements.filter(x => x.elementDescription == "IsDocSetRequired")[0];
                    if (!!isDocSetRequiredElement) {
                        this.isDocSetRequired = isDocSetRequiredElement.isMandatory;
                        if (!this.isDocSetRequired) {
                            this.docScheduleForm.get('docSet')?.clearValidators();
                            this.docScheduleForm.get('docSet')?.updateValueAndValidity();
                            this.docScheduleForm.get('formDocSet')?.clearValidators();
                            this.docScheduleForm.get('formDocSet')?.updateValueAndValidity();
                            this.IsDisabled = false;
                        }
                    }
                    let isWBSIntegrationElement = this.projectStaticElements.filter(x => x.elementDescription == "WBS Integration")[0];
                    if (!!isWBSIntegrationElement) {
                        this.isWBSIntegration = isWBSIntegrationElement.isMandatory;
                    }

                    let SetDCIMaxProgressLevel: IProjectElementsOutput = this.projectStaticElements.filter(x => x.elementDescription == "Set DCI Max Progress Level")[0];
                    if (!!SetDCIMaxProgressLevel)
                        if (SetDCIMaxProgressLevel.isVisible)
                            this.SetDCIMaxProgressLevel = SetDCIMaxProgressLevel;
                }
            }, err => {
                this._notificationService.showToast("failed to get static element details", "Warning");
            });
        if (this.isDocSetRequired)
            this.getDocSetList();
    }

    getStageDate(selectedStageDate: any, stage: IStageElementDetails) {
        stage.selected_Date = selectedStageDate.value;
        if (this.scheduleWFPlanStageDetails.length > 0) {
            let scheduleWfPlan: IScheduleWFPlanStageDetails = this.scheduleWFPlanStageDetails.filter(x => x.status_Id == stage.stage_Id)[0];
            scheduleWfPlan.scheduled_On = stage.selected_Date;
        }
    }

    private getFormValue(form: FormGroup, formControlName: string): any {
        return form.get(formControlName)?.value;
    }

    closeDialog() {
        this._dialogRef.close();
    }

    cancelScheduleDoc() {
        this.closeDialog();
    }

    numberOnly(event: any, field: any = null): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (['weightage', 'enggMH', 'draftMH'].includes(field)) {
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
                return false;
            } else {
                return true;
            }
        } else {
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                return false;
            } else {
                return true;
            }
        }
    }
    public getDocCategoryValue(selectedText: { value: number; }) {
        this.selectedDCICodeIdValue = selectedText.value;
        this.revForm.get("docCategoryid")?.setValue(selectedText.value);
    }

    getWBSCodes() {
        this._projectService.getProjects(this.projectId, this.memberId).subscribe((data: IProjectMasterViewModel[]) => {
            this.JOBCode = data[0].job_Code;
            this._scheduleDocService.GetWBSCodes({ job_Code: this.JOBCode })
                .subscribe((res) => {
                    this.wbsList = res;
                });
        });
    }
    setWBSCode(event: EIPAutoCompleteEventModel<IWBSOutputModel>) {
        if (event.value != '-2') {
            this.dciForm.get('wbsCode')?.setValue(event.value);
            this.dciForm.get('wbsCode')?.setValue(event.text);
            this.WBSCode = event.value.toString();
            if (!!this.WBSCode) {
                this._scheduleDocService.GetDeliverableCodes({ job_Code: this.JOBCode, wBS_Code: this.WBSCode })
                    .subscribe((res) => {
                        this.dvcodeList = res;
                    });
            }
        }
        else {
            this.dciForm.get('wbsCode')?.setValue(null);
            this.dvcodeList = [];
            this.WBSCode = null;
            this.DeliverableCode = null;
        }
    }
    setDVCode(event: EIPAutoCompleteEventModel<ICPCDocOutputModel>) {
        if (event.value != '-2') {
            this.dciForm.get('dvCode')?.setValue(event.value);
            this.dciForm.get('dvCode')?.setValue(event.text);
            this.DeliverableCode = +event.value
        }
        else {
            this.dciForm.get('dvCode')?.setValue(null);
            this.DeliverableCode = null
        }
    }

}